import { instance, referralSecureApi } from './base'
import { AxiosResponse } from 'axios'
import {
  User,
  BalanceItem,
  PayRequest,
  PartnerListItem,
  PartnerListResponse,
  Client,
  PotentialProfit,
  Widget,
  Comment,
  Feed,
  ReferralStats,
  CommissionStatus,
  ClientsStats,
  SubscriptionStatus,
  UserModalData,
  UserLeadsInfo,
  ChartData,
  PaginatedResponse,
  SSOLoginResponse,
  ReferralLink,
} from '../types'
import {
  UpdateMeRequest,
  AddRequisitesRequest,
  AddPartnerRequest,
  AddManualClientRequest,
  CommissionStatusRequest,
  UpdateUserRequestParams,
  AddCommentRequest,
  CreateReferralLinkRequest,
} from '../types'

const API_GLOBAL_PREFIX = `api`

export const getMe = async (): Promise<AxiosResponse<User>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/me`)
}

export const updateMe = async (data: UpdateMeRequest): Promise<AxiosResponse<User>> => {
  return await referralSecureApi.post(`${API_GLOBAL_PREFIX}/me`, data)
}

export const getCommonChartData = async (): Promise<AxiosResponse<ChartData>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/common-chart`)
}

export const getLeadsTodayData = async (): Promise<AxiosResponse<Client[]>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/leads-today`)
}

export const getLeadsData = async ({ page }: { page: number }): Promise<AxiosResponse<PaginatedResponse<Client>>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/leads?page=${page}`)
}

export const getLeadsDataAdm = async ({
  page,
}: {
  page: number
}): Promise<AxiosResponse<PaginatedResponse<Client>>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/leads-data-adm?page=${page}`)
}

export const getMyFeeds = async (): Promise<AxiosResponse<Feed[]>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/my-feeds`)
}

export const addRequisites = async (data: AddRequisitesRequest): Promise<AxiosResponse> => {
  try {
    const response = await referralSecureApi.post(`${API_GLOBAL_PREFIX}/referral/add-requisites`, data)
    return response
  } catch (error: any) {
    console.error('Error:', error.response ? error.response.data : error.message)
    throw error
  }
}

export const getRequisites = async (): Promise<AxiosResponse> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/requisites/`)
}

export const getUserRequisites = async ({ user_id }: { user_id: string }): Promise<AxiosResponse> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/adm/user-requisites?user_id=${user_id}`)
}

export const getWithdrawalHistory = async (): Promise<AxiosResponse<PayRequest[]>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/withdrawal-history`)
}

export const addPayRequest = async (data: { amount: number }): Promise<AxiosResponse<PayRequest>> => {
  try {
    const response = await referralSecureApi.post(`${API_GLOBAL_PREFIX}/referral/pay-requests`, data)
    return response
  } catch (error: any) {
    const errorMessage = error.response ? error.response.data : error.message
    throw new Error(errorMessage)
  }
}

export const getRequest = async (): Promise<AxiosResponse<PayRequest[]>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/pay-requests`)
}

export const getBalance = async (): Promise<BalanceItem[]> => {
  try {
    const response = await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/user-balance`)
    return response.data
  } catch (error: any) {
    console.error('Error fetching user balance:', error.response ? error.response.data : error.message)
    throw error
  }
}

export const getPotentialProfit = async (): Promise<PotentialProfit> => {
  try {
    const response = await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/user-potential-profit`)
    return response.data
  } catch (error: any) {
    console.error('Error fetching user potential profit:', error.response ? error.response.data : error.message)
    throw error
  }
}

export const updateWidgetImage = async (data: FormData, widgetId: string): Promise<AxiosResponse<Widget>> => {
  return await referralSecureApi.post(`${API_GLOBAL_PREFIX}/referral/update-img/${widgetId}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const updateWidgetImageAdm = async (data: FormData, widgetId: string): Promise<AxiosResponse<Widget>> => {
  return await referralSecureApi.post(`${API_GLOBAL_PREFIX}/referral/update-img-adm/${widgetId}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const getMyWidget = async (widget_id: string): Promise<AxiosResponse<Widget>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/widget/${widget_id}`)
}

export const getCommonWidget = async (widget_id: string): Promise<AxiosResponse<Widget>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/w/${widget_id}`)
}

export const getWidgetData = async (widget_id: string): Promise<AxiosResponse<Widget>> => {
  return await instance.get(`${API_GLOBAL_PREFIX}/referral/w/${widget_id}`)
}

export const checkPhoneNumber = async ({ phone }: { phone: string }): Promise<AxiosResponse> => {
  return await instance.get(`${API_GLOBAL_PREFIX}/referral/check-seances?phone=${phone}`)
}

export const checkPhoneInAgentsProgram = async ({ phone }: { phone: string }): Promise<AxiosResponse> => {
  return await instance.get(`${API_GLOBAL_PREFIX}/referral/lead/count?phone=${phone}`)
}

export const sendLeadToDB = async (data: any): Promise<AxiosResponse> => {
  return await instance.post(`${API_GLOBAL_PREFIX}/referral/webhook/mlm`, data)
}

export const getUsersAdm = async (): Promise<AxiosResponse> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/adm/users`)
}

export const getPayRequestsAdm = async ({ types }: { types: string }): Promise<AxiosResponse<PayRequest[]>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/adm/requests?types=${types}`)
}

export const getRequestUserData = async ({ user_id }: { user_id: string }): Promise<AxiosResponse<UserModalData>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/adm/user-data?user_id=${user_id}`)
}

export const getRequestUserLeadsInfo = async ({
  user_id,
}: {
  user_id: string
}): Promise<AxiosResponse<UserLeadsInfo>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/adm/user-clients-info?user_id=${user_id}`)
}

export const getUserClientsAdm = async ({
  user_id,
  page,
}: {
  user_id: string
  page: number
}): Promise<AxiosResponse<PaginatedResponse<Client>>> => {
  return await referralSecureApi.get(
    `${API_GLOBAL_PREFIX}/referral/adm/user-clients-data?user_id=${user_id}&page=${page}`,
  )
}

export const updateUserRequest = async ({
  type,
  comment,
  request_id,
}: UpdateUserRequestParams): Promise<AxiosResponse> => {
  return await referralSecureApi.post(`${API_GLOBAL_PREFIX}/referral/adm/request/update`, {
    type,
    comment,
    request_id,
  })
}

export const getClientComments = async ({ parent_id }: { parent_id: string }): Promise<AxiosResponse<Comment[]>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/comments?parent_type=client&parent_id=${parent_id}`)
}

export const addClientComment = async ({ comment, parent_id }: AddCommentRequest): Promise<AxiosResponse<Comment>> => {
  return await referralSecureApi.post(`${API_GLOBAL_PREFIX}/referral/comments`, {
    comment: comment,
    parent_type: 'client',
    parent_id,
  })
}

export const updateAvatar = async (image: FormData): Promise<AxiosResponse<User>> => {
  return await referralSecureApi.post(`${API_GLOBAL_PREFIX}/referral/update-avatar`, image)
}

export const generateReferralLink = async (
  data: CreateReferralLinkRequest,
): Promise<AxiosResponse<{ referralLink: string }>> => {
  return await referralSecureApi.post(`${API_GLOBAL_PREFIX}/referral/generate-link`, data)
}

export const getReferralStats = async (): Promise<AxiosResponse<ReferralStats>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/stats`)
}

export const addManualClient = async (clientData: AddManualClientRequest): Promise<AxiosResponse<Client>> => {
  return await referralSecureApi.post(`${API_GLOBAL_PREFIX}/referral/clients/manual`, clientData)
}

export const getManualClientsStats = async (): Promise<AxiosResponse<ClientsStats>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/clients/manual/stats`)
}

export const getSubscriptionStatus = async (): Promise<AxiosResponse<SubscriptionStatus>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/subscription/status`)
}

export const paySubscription = async (): Promise<AxiosResponse> => {
  return await referralSecureApi.post(`${API_GLOBAL_PREFIX}/referral/subscription/pay`, {})
}

// SSO Login - вход через SSO токен
export const ssoLogin = async (ssoToken: string): Promise<AxiosResponse<SSOLoginResponse>> => {
  return await instance.post(
    `api/auth/seamless/validate`,
    {},
    {
      headers: { Authorization: `Bearer ${ssoToken}` },
      withCredentials: true,
    },
  )
}

// Реферальные ссылки - получение всех ссылок
export const getReferralLinks = async (): Promise<AxiosResponse<ReferralLink[]>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/link`)
}

// Реферальные ссылки - создание новой ссылки
export const createReferralLink = async (data: CreateReferralLinkRequest): Promise<AxiosResponse<ReferralLink>> => {
  return await referralSecureApi.post(`${API_GLOBAL_PREFIX}/referral/link/generate`, data)
}

// Реферальные ссылки - активация/деактивация ссылки
export const toggleReferralLink = async (linkId: string, isActive: boolean): Promise<AxiosResponse<ReferralLink>> => {
  return await referralSecureApi.patch(`${API_GLOBAL_PREFIX}/referral/link/${linkId}/toggle`, { isActive })
}

// Реферальные ссылки - клонирование ссылки
export const cloneReferralLink = async (
  linkId: string,
  data: CreateReferralLinkRequest,
): Promise<AxiosResponse<ReferralLink>> => {
  return await referralSecureApi.post(`${API_GLOBAL_PREFIX}/referral/link/${linkId}/clone`, data)
}

// Реферальные ссылки - получение полного URL по короткому коду
export const getReferralLinkByCode = async (refCode: string): Promise<AxiosResponse<{ url: string }>> => {
  return await instance.get(`${API_GLOBAL_PREFIX}/referral/link/r/${refCode}`)
}

/**
 * Мои клиенты. Получение списка клиентов
 */
export interface GetClientsParams {
  page?: number
  limit?: number
  sortBy?: string
  sortDir?: 'ASC' | 'DESC'
  status?: string
}
export const getMyClients = async (params: GetClientsParams = {}): Promise<AxiosResponse<ChartData>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/client`)
}

/**
 * Настройка комиссий. Получить список всех настроек статусов партнера
 */
export const getCommissionStatuses = async (): Promise<AxiosResponse<CommissionStatus[]>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/commission/status`)
}

/**
 * Настройка комиссий. Создать новую настройку статуса партнера
 */
export const createCommissionStatus = async (
  data: CommissionStatusRequest,
): Promise<AxiosResponse<CommissionStatus>> => {
  return await referralSecureApi.post(`${API_GLOBAL_PREFIX}/commission/status`, data)
}

/**
 * Настройка комиссий. Обновить настройку статуса партнера
 */
export const updateCommissionStatus = async (
  statusId: string,
  data: CommissionStatusRequest,
): Promise<AxiosResponse<CommissionStatus>> => {
  return await referralSecureApi.put(`${API_GLOBAL_PREFIX}/commission/status/${statusId}`, data)
}

/**
 * Настройка комиссий. Удалить настройку статуса партнера
 */
export const deleteCommissionStatus = async (statusId: string): Promise<AxiosResponse> => {
  return await referralSecureApi.delete(`${API_GLOBAL_PREFIX}/commission/status/${statusId}`)
}

/**
 * Мои партнеры. Получить список всех партнеров
 */
export interface GetPartnersParams {
  page?: number
  limit?: number
  sortBy?: string
  sortDir?: 'ASC' | 'DESC'
}

export const getMyPartners = async (params: GetPartnersParams = {}): Promise<AxiosResponse<PartnerListResponse>> => {
  return await referralSecureApi.get(`${API_GLOBAL_PREFIX}/referral/partner`, { params })
}

/**
 * Мои партнеры. Добавить партнера
 */
export const addMyPartner = async (data: AddPartnerRequest): Promise<AxiosResponse<PartnerListItem>> => {
  return await referralSecureApi.post(`${API_GLOBAL_PREFIX}/referral/partner`, data)
}
